<template>
  <b-modal
    id="modal-pinned-usersModal"
    :title="$t('add_zakrep')"
    cancel-variant="outline-secondary"
    :ok-title="$t('save')"
    ok-variant="success"
    :cancel-title="$t('cancel')"
    size="xl"
    centered
    no-close-on-backdrop
    @show="fetchModal"
    @ok="onSubmitWarehouseId"
  >
    <b-form>
      <b-row>
        <b-col class="col-md-2">
          <AppSearchInput
            :label="$t('namee')"
            :placeholder="$t('namee')"
            @callback="search"
          />
        </b-col>
      </b-row>
      <b-table
        :fields="fields"
        :items="GET_WAREHOUSE"
        show-empty
        hover
        responsive
        :empty-text="$t('empty_text')"
        :sticky-header="stickyHeader"
        :no-border-collapse="noCollapse"
      >
        <template #head()="props">
          <span>{{ $t(props.label) }}</span>
        </template>

        <template #cell(fio)="props">
          <span>{{ props.item.title }}</span>
        </template>

        <template #cell(username)="props">
          <span>{{ props.item.username }}</span>
        </template>

        <template #cell(status)="props">
          <b-form-checkbox
            class="m-0"
            :checked="props.item.status"
            name="check-button"
            switch
            inline
          />
        </template>

        <template #cell(role)="props">
          <div class="d-flex flex-wrap align-items-center justify-content-center">
            <b-badge
              v-for="item in props.item.user_role"
              :key="item.id"
              variant="info"
              class="mr-25"
            >
              {{ item }}
            </b-badge>
          </div>
        </template>

        <template #cell(actions)="props">
          <div class="d-flex align-items-center justify-content-end">
            <b-form-checkbox
              v-model="props.item.actions"
              class="mr-1 mt-50 mb-50"
              @input="selectionChange($event, props.item.id)"
            />
          </div>
        </template>
      </b-table>



    </b-form>
  </b-modal>
</template>

<script>
import {
  BModal,
  VBModal,
  BForm,
  BFormCheckbox,
  BTable,
  BRow,
  BCol,
  BBadge,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import { mapActions, mapGetters } from 'vuex'
import AppSearchInput from '@/components/AppSearchInput.vue'

export default {
  name: 'PinnedUsersModal',
  components: {
    BModal,
    BForm,
    BFormCheckbox,
    BTable,
    BRow,
    BCol,
    BBadge,
    AppSearchInput,
  },
  directives: {
    'b-modal': VBModal,
    Ripple,
  },
  props: {
    object: {
      type: Object,
      default: null,
      required: false,
    },
  },
  data() {
    return {



      // ===============  PRIMARY_DATA_SECTION START ===============
      selected_rows: [],
      nobody: true,
      stickyHeader: true,
      noCollapse: true,
      filtered: {
        search: null,
      },
      // ===============  PRIMARY_DATA_SECTION END ===============





      // ===============  OTHERS_SECTION START ===============
      fields: [
        {
          label: 'ID',
          key: 'id',
        },
        {
          label: 'namee',
          key: 'fio',
          tdClass: 'text-center',
          thClass: 'text-center',
        },
        {
          label: 'login',
          key: 'username',
          tdClass: 'text-center',
          thClass: 'text-center',
        },
        {
          label: 'role',
          key: 'role',
          tdClass: 'text-center',
          thClass: 'text-center w-200',
        },
        {
          label: 'actions',
          key: 'actions',
          tdClass: 'text-right',
          thClass: 'text-right',
        },
      ],
      // ===============  OTHERS_SECTION END ===============



      
    }
  },

  computed: {
    ...mapGetters('obectsWarehouse', ['GET_WAREHOUSE']),
  },

  methods: {
    ...mapActions('obectsWarehouse', ['FETCH_WAREHOUSE_ID', 'UPDATE_CHECKBOX', 'FETCH_WAREHOUSE_LEFT_TABLE', 'FETCH_WAREHOUSE']),







    // ===============  OTHERS_SECTION START ===============
    async fetchModal() {
      await this.FETCH_WAREHOUSE({
        rc_object: 0,
        is_object: 0,
        partial: 1,
        search: this.filtered.search
      })
    },
    selectionChange(val, id) {
      const index_id = this.selected_rows.indexOf(id)
      if (val) {
        this.selected_rows.push(id)
      } else {
        this.selected_rows.splice(index_id, 1)
      }
    },
    async search(text) {
      this.filtered.search = text
      await this.fetchModal()
    },
    // ===============  OTHERS_SECTION END ===============







    // ===============  ON_SUBMIT_SECTION START ===============
    onSubmitWarehouseId(bvModalEvt) {
      bvModalEvt.preventDefault()
      this.selected_rows.forEach(async (e, i) => {
        await this.UPDATE_CHECKBOX({
          object: this.object.id,
          is_object: 0,
          id: e,
        })
          .then( async () => {
            if (this.selected_rows.length - 1 === i) {
              await this.FETCH_WAREHOUSE_LEFT_TABLE({
                object: this.object.id,
                is_object: 0,
              })
              this.$nextTick(() => {
                this.$bvModal.hide('modal-pinned-usersModal')
              })
            }
          })
      })
    },
    // ===============  ON_SUBMIT_SECTION END ===============






    
  },
}
</script>
